"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticator = exports.isBackendForFrontendConfig = exports.isTokenProviderConfig = exports.isOidcConfig = exports.isAccessToken = void 0;
var tokenprovider_1 = require("@migros/tokenprovider");
var config_1 = require("./config");
var globalObject = typeof window !== 'undefined' ? window : global;
var isAccessToken = function (token) {
    return token.token !== undefined && token.expiresAt !== undefined;
};
exports.isAccessToken = isAccessToken;
var isOidcConfig = function (config) {
    return config.authority !== undefined;
};
exports.isOidcConfig = isOidcConfig;
var isTokenProviderConfig = function (config) {
    var _a, _b;
    return (((_a = config.events) === null || _a === void 0 ? void 0 : _a.loginEvent) !== undefined &&
        ((_b = config.events) === null || _b === void 0 ? void 0 : _b.logoutEvent) !== undefined &&
        config.getUser === undefined &&
        config.isLoggedIn === undefined);
};
exports.isTokenProviderConfig = isTokenProviderConfig;
var isBackendForFrontendConfig = function (config) {
    var _a, _b;
    return (((_a = config.events) === null || _a === void 0 ? void 0 : _a.loginEvent) !== undefined &&
        ((_b = config.events) === null || _b === void 0 ? void 0 : _b.logoutEvent) !== undefined &&
        config.getUser !== undefined &&
        config.isLoggedIn !== undefined);
};
exports.isBackendForFrontendConfig = isBackendForFrontendConfig;
var Authenticator = /** @class */ (function () {
    function Authenticator(config) {
        this.config = config;
        if ((0, exports.isTokenProviderConfig)(config)) {
            this.type = config_1.AUTHENTICATOR_TYPES.TOKEN_PROVIDER;
        }
        else if ((0, exports.isOidcConfig)(config)) {
            this.type = config_1.AUTHENTICATOR_TYPES.OIDC;
        }
        else if ((0, exports.isBackendForFrontendConfig)(config)) {
            this.type = config_1.AUTHENTICATOR_TYPES.BACKEND_FOR_FRONTEND;
        }
        else {
            throw new Error('Invalid config provided. Expected either OidcConfig, TokenProviderConfig or BackendForFrontendConfig.');
        }
    }
    Authenticator.getInstance = function () {
        if (globalObject.MigrosSharedAuthenticator === undefined) {
            throw new Error('Not initialized');
        }
        return globalObject.MigrosSharedAuthenticator;
    };
    Authenticator.initBackendForFrontend = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(0, exports.isBackendForFrontendConfig)(config)) {
                    throw new Error('Invalid config provided. Expected BackendForFrontendConfig.');
                }
                if (globalObject.MigrosSharedAuthenticator === undefined) {
                    globalObject.MigrosSharedAuthenticator = new Authenticator(config);
                }
                else {
                    console.warn('MigrosSharedAuthenticator is already initialized. Make sure `Authenticator.initBackendForFrontend` is only called once and before loading any other user related scripts.', globalObject.MigrosSharedAuthenticator);
                }
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    Authenticator.initTokenProviderEvents = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!(0, tokenprovider_1.hasTokenProvider)()) {
                    console.warn('MigrosTokenProvider is not set! Make sure to initialize the TokenProvider before calling `Authenticator.initTokenProviderEvents`.');
                }
                if (globalObject.MigrosSharedAuthenticator === undefined) {
                    globalObject.MigrosSharedAuthenticator = new Authenticator({ events: events });
                }
                else {
                    console.warn('MigrosSharedAuthenticator is already initialized. Make sure `Authenticator.initTokenProviderEvents` is only called once and before loading any other user related scripts.', globalObject.MigrosSharedAuthenticator);
                }
                Authenticator.loginLogoutEvents = events;
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    Authenticator.init = function () {
        return __awaiter(this, arguments, void 0, function (config) {
            if (config === void 0) { config = {}; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(globalObject.MigrosSharedAuthenticator === undefined)) return [3 /*break*/, 2];
                        globalObject.MigrosSharedAuthenticator = new Authenticator(config);
                        return [4 /*yield*/, Authenticator.getInstance().autologin()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        console.warn('MigrosSharedAuthenticator is already initialized. Make sure `Authenticator.init` is only called once.');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Authenticator.resetAuthenticator = function () {
        if (globalObject.MigrosSharedAuthenticator !== undefined) {
            delete globalObject.MigrosSharedAuthenticator;
            delete Authenticator.autologinPromise;
            delete Authenticator.loginLogoutEvents;
        }
    };
    Authenticator.prototype.login = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (options === null || options === void 0 ? void 0 : options.loginUrl) {
                            window.location.href = options.loginUrl;
                            return [2 /*return*/];
                        }
                        localStorage.setItem(config_1.MANUAL_LOGIN_TIMESTAMP_COOKIE, Date.now().toString());
                        localStorage.setItem(config_1.MSC_OIDC_RETURN_TO, (_a = options === null || options === void 0 ? void 0 : options.returnTo) !== null && _a !== void 0 ? _a : window.location.href);
                        return [4 /*yield*/, this.getHandler()];
                    case 1: return [4 /*yield*/, (_b.sent()).login(options)];
                    case 2: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    Authenticator.prototype.logout = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        localStorage.setItem(config_1.MANUAL_LOGIN_TIMESTAMP_COOKIE, Date.now().toString());
                        localStorage.removeItem(config_1.AUTO_LOGIN_TIMESTAMP_COOKIE);
                        localStorage.setItem(config_1.MSC_OIDC_RETURN_TO, (_a = options === null || options === void 0 ? void 0 : options.returnTo) !== null && _a !== void 0 ? _a : window.location.href);
                        return [4 /*yield*/, this.getHandler()];
                    case 1: return [2 /*return*/, (_b.sent()).logout(options)];
                }
            });
        });
    };
    Authenticator.prototype.autologin = function () {
        return __awaiter(this, arguments, void 0, function (forceUserReload) {
            var promise;
            var _this = this;
            if (forceUserReload === void 0) { forceUserReload = false; }
            return __generator(this, function (_a) {
                if (!forceUserReload && Authenticator.autologinPromise) {
                    return [2 /*return*/, Authenticator.autologinPromise];
                }
                promise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.getHandler()];
                            case 1: return [4 /*yield*/, (_a.sent()).autologin(forceUserReload)];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); })();
                Authenticator.autologinPromise = promise;
                return [2 /*return*/, promise];
            });
        });
    };
    Authenticator.prototype.isLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandler()];
                    case 1: return [2 /*return*/, (_a.sent()).isLoggedIn()];
                }
            });
        });
    };
    Authenticator.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandler()];
                    case 1: return [2 /*return*/, (_a.sent()).getToken()];
                }
            });
        });
    };
    Authenticator.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHandler()];
                    case 1: return [2 /*return*/, (_a.sent()).getUser()];
                }
            });
        });
    };
    Authenticator.prototype.getHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var TokenProviderHandler, OidcHandler, BackendForFrontendHandler;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.handler) {
                            return [2 /*return*/, this.handler];
                        }
                        if (!((0, exports.isTokenProviderConfig)(this.config) && (0, tokenprovider_1.hasTokenProvider)())) return [3 /*break*/, 2];
                        return [4 /*yield*/, require('./handlers/tokenProviderHandler')];
                    case 1:
                        TokenProviderHandler = (_a.sent()).TokenProviderHandler;
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                        this.handler = new TokenProviderHandler(this.config);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(0, exports.isOidcConfig)(this.config)) return [3 /*break*/, 4];
                        return [4 /*yield*/, require('./handlers/oidcHandler')];
                    case 3:
                        OidcHandler = (_a.sent()).OidcHandler;
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                        this.handler = new OidcHandler(this.config);
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(0, exports.isBackendForFrontendConfig)(this.config)) return [3 /*break*/, 6];
                        return [4 /*yield*/, require('./handlers/backendForFrontendHandler')];
                    case 5:
                        BackendForFrontendHandler = (_a.sent()).BackendForFrontendHandler;
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                        this.handler = new BackendForFrontendHandler(this.config);
                        _a.label = 6;
                    case 6:
                        if (!this.handler) {
                            throw new Error('Invalid config provided. Expected either OidcConfig, TokenProviderConfig or BackendForFrontendConfig.');
                        }
                        return [2 /*return*/, this.handler];
                }
            });
        });
    };
    return Authenticator;
}());
exports.Authenticator = Authenticator;
